import { documentHasElements } from "modules/dom";

documentHasElements(".js-country-selector-block", (CountrySelectorBlocks) => {
    CountrySelectorBlocks.forEach((CountrySelectorBlock) => {

        window.addEventListener("load", () => {
            const linkButton = CountrySelectorBlock.querySelector<HTMLAnchorElement>(".link-button");
            const selectOptions = CountrySelectorBlock.querySelectorAll<HTMLLIElement>(".select-panel li:not(.select-search, .select-no-hits)");
            const clearButton = CountrySelectorBlock.querySelector<HTMLButtonElement>(".clear-filter");
            const selectToggle = CountrySelectorBlock.querySelector<HTMLButtonElement>(".select-toggle span");

            const languageIcon = '<svg class="lang-icon"><use xlink: href = "/images/securitas.spritemap.svg#sprite-globe"></use></svg>';
            selectToggle?.insertAdjacentHTML('beforebegin', languageIcon);

            selectOptions.forEach((option) => {
                const flagIcon = '<div><img src = "https://flagcdn.com/' + option.getAttribute("data-select-lang")?.toLowerCase() + '.svg" height = "24" alt = "' + option.getAttribute("title") + '" ></div> ';
                option.insertAdjacentHTML('afterbegin', flagIcon);

                option.addEventListener("click", () => {
                    const href = option.dataset.selectValue;

                    if (!href || !linkButton) return;

                    linkButton.href = href;
                    linkButton.classList.remove("disabled");
                });
            });

            clearButton?.addEventListener("click", () => {
                linkButton?.classList.add("disabled");
            });
        });

    });
});